import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { CurrentBalanceEntity } from "../entities/CurrentBalanceEntity";

export class GetCurrentBalanceUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(): Promise<CurrentBalanceEntity> {
    return this.repository.getCurrentBalance();
  }
}

